import React from 'react'
import { Menu } from 'lucide-react'
import Logo from '../common/Logo'

interface TopBarProps {
  onToggleSidebar: () => void
  isSidebarOpen: boolean
}

const TopBar: React.FC<TopBarProps> = ({ onToggleSidebar, isSidebarOpen }) => {
  return (
    <div className="topbar">
      <button
        className="topbar__toggle"
        onClick={onToggleSidebar}
        aria-label="Toggle sidebar"
      >
        <Menu size={18} />
      </button>

      <div
        className={`topbar__logo ${
          isSidebarOpen ? 'topbar__logo--hidden' : ''
        }`}
      >
        <Logo
          className="topbar__logo-container"
          logoClassName="topbar__logo-image"
          textClassName="topbar__logo-text"
        />
      </div>

      <div className="topbar__spacer" />
    </div>
  )
}

export default TopBar
